import { render, staticRenderFns } from "./platformAccount.vue?vue&type=template&id=3c666f12&scoped=true&"
import script from "./platformAccount.vue?vue&type=script&lang=js&"
export * from "./platformAccount.vue?vue&type=script&lang=js&"
import style0 from "./platformAccount.vue?vue&type=style&index=0&id=3c666f12&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c666f12",
  null
  
)

export default component.exports